module.exports = __webpack_public_path__ + "static/media/icon-sportsequip.79b51f52.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/WizardInvitee/parts/images/icon-sportsequip.svg
// module id = 1003
// module chunks = 0